import { createReducer } from '@reduxjs/toolkit';
import {
    incrementWalletAttempts,
    resetWalletAttempts,
    setCpaProducts,
    setCpaProductsLoading,
    setCpaProductsRecomendations,
    setCpaProductsRecomendationsLoading,
    setCpaProductsSuggest,
    setCpaProductsSuggestLoading,
    setCpaShops,
    setCpaShopsLoading,
    setCpaShopsRecomendations,
    setCpaShopsRecomendationsLoading,
    setCpaShopsSuggest,
    setCpaShopsSuggestLoading,
    setWalletInfo,
    setWalletInfoLoading,
} from './actions';
import type { CpaState } from './types';

const initialState: CpaState = {
    walletInfo: undefined,
    isLoading: false,
    attemptCount: 0,
    shops: {
        items: undefined,
        isLoading: false,
    },
    shopsSuggest: {
        items: undefined,
        isLoading: false,
    },
    shopsRecomendations: {
        items: undefined,
        isLoading: false,
    },
    products: {
        items: undefined,
        isLoading: false,
    },
    productsSuggest: {
        items: undefined,
        isLoading: false,
    },
    productsRecomendations: {
        items: undefined,
        isLoading: false,
    },
};

export const cpaReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setWalletInfo, (draft, action) => {
            draft.walletInfo = action.payload;
        })
        .addCase(setWalletInfoLoading, (draft, action) => {
            draft.isLoading = action.payload;
        })
        .addCase(incrementWalletAttempts, (draft) => {
            draft.attemptCount += 1;
        })
        .addCase(resetWalletAttempts, (draft) => {
            draft.attemptCount = 0;
        })
        .addCase(setCpaShopsLoading, (draft, action) => {
            draft.shops.isLoading = action.payload;
        })
        .addCase(setCpaShops, (draft, action) => {
            const { payload } = action;

            draft.shops.items = payload.items || [];
        })
        .addCase(setCpaShopsSuggestLoading, (draft, action) => {
            draft.shopsSuggest.isLoading = action.payload;
        })
        .addCase(setCpaShopsSuggest, (draft, action) => {
            draft.shopsSuggest.items = action.payload || [];
        })
        .addCase(setCpaShopsRecomendationsLoading, (draft, action) => {
            draft.shopsRecomendations.isLoading = action.payload;
        })
        .addCase(setCpaShopsRecomendations, (draft, action) => {
            const { payload } = action;

            draft.shopsRecomendations.items = payload.items || [];
        })
        .addCase(setCpaProductsRecomendationsLoading, (draft, action) => {
            draft.productsRecomendations.isLoading = action.payload;
        })
        .addCase(setCpaProductsRecomendations, (draft, action) => {
            const { payload } = action;

            draft.productsRecomendations.items = payload.items || [];
        })
        .addCase(setCpaProductsLoading, (draft, action) => {
            draft.products.isLoading = action.payload;
        })
        .addCase(setCpaProducts, (draft, action) => {
            const { payload } = action;

            draft.products.items = payload.items || [];
        })
        .addCase(setCpaProductsSuggestLoading, (draft, action) => {
            draft.productsSuggest.isLoading = action.payload;
        })
        .addCase(setCpaProductsSuggest, (draft, action) => {
            draft.productsSuggest.items = action.payload || [];
        });
});
